import React, { Component } from "react";
import moment from "moment";
// import { NavLink } from "react-router-dom";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { MainBusinessHoursHome } from "./MainBusinessHoursHome";
import { AreYouOpen } from "./InsideBusinessHoursScreen/AreYouOpen";
import StandardHours from "./InsideBusinessHoursScreen/StandardHours";
import { MultipleStandardHours } from "./InsideBusinessHoursScreen/MultipleStandardHours";
import TimeInput from "material-ui-time-picker";
import Switch from "react-switch";
import {
  // InputBoxComponent,
  NewInputText,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { InputCharacterCheck } from "../../../../function/InputCharNumCheckFunc";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { TogglePopup } from "./InsideBusinessHoursScreen/TogglePopup";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import BusinessHoursMultiplePopup from "./PopupScreen/BusinessHoursMultiplePopup";
import Media from "react-media";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { SliderMobileReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent";

const foodTime = ["breakfast", "lunch", "dinner"];

const dayArray = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const dayData = {
  open: false,
  breakfast: {
    open: false,
    opening_time: new Date(2020, 1, 1, 8),
    closing_time: new Date(2020, 1, 1, 11),
  },
  lunch: {
    open: false,
    opening_time: new Date(2020, 1, 1, 13),
    closing_time: new Date(2020, 1, 1, 15),
  },
  dinner: {
    open: false,
    opening_time: new Date(2020, 1, 1, 17),
    closing_time: new Date(2020, 1, 1, 23),
  },
  multipleHours: [
    {
      open: true,
      opening_time: new Date(2020, 1, 1, 8),
      closing_time: new Date(2020, 1, 1, 23),
      description: "",
    },
  ],
};

export class MainBusinessHours extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAreYouOpenTogglePop: false,
      checkPoint: false,
      actionButton: false,
      setMultipleTimes: false,
      loader: false,
      hasSetMapProps: false,
      selectedT: false,
      displayAreYouOpen: false,
      displayAreYouOpenInside: false,
      displayStandardHours: false,
      displayStandardHoursInside: false,
      displayMultipleStandardHours: false,
      displayMultipleStandardHoursInside: false,

      areYouOpen: false,
      multipleHoursOpening: true,
      timeZoneOffset: new Date().getTimezoneOffset(),
      monday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      tuesday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      wednesday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      thursday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      friday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      saturday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      sunday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      errors: [],
      formShow: false,
    };
    this.handleChangeAreYouOpen = this.handleChangeAreYouOpen.bind(this);
    this.handleChangeMultipleOpeningTimes =
      this.handleChangeMultipleOpeningTimes.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.onboarding._id) && !nextState.hasSetMapProps) {
      return {
        hasSetMapProps: true,
        areYouOpen: !isEmpty(nextProps.onboarding.are_you_open_24_x_7)
          ? nextProps.onboarding.are_you_open_24_x_7
          : false,
        multipleHoursOpening: !isEmpty(
          nextProps.onboarding.multiple_opening_time
        )
          ? nextProps.onboarding.multiple_opening_time
          : true,
        displayBusinessHours: !isEmpty(
          nextProps.onboarding.display_business_hours
        )
          ? nextProps.onboarding.display_business_hours
          : false,
        // displayAreYouOpen: !isEmpty(
        //   nextProps.onboarding.display_are_you_open_inside ||
        //     nextProps.onboarding.are_you_open_24_x_7
        // )
        //   ? nextProps.onboarding.display_are_you_open_inside ||
        //     nextProps.onboarding.are_you_open_24_x_7
        //   : false,
        // displayAreYouOpenInside: !isEmpty(
        //   nextProps.onboarding.display_are_you_open_inside
        // )
        //   ? nextProps.onboarding.display_are_you_open_inside
        //   : false,
        // displayStandardHoursInside: !isEmpty(
        //   nextProps.onboarding.display_standard_hours_inside
        // )
        //   ? nextProps.onboarding.display_standard_hours_inside
        //   : false,
        // displayMultipleStandardHours:
        //   !isEmpty(
        //     nextProps.onboarding.display_multiple_standard_hours_inside
        //   ) ||
        //   nextProps.onboarding.display_multiple_standard_hours_inside === true
        //     ? false
        //     : true,
        displayMultipleStandardHoursInside: !isEmpty(
          nextProps.onboarding.display_multiple_standard_hours_inside
        )
          ? false
          : // ? nextProps.onboarding.display_multiple_standard_hours_inside
            false,
        monday: !isEmpty(nextProps.onboarding.monday)
          ? nextProps.onboarding.monday
          : dayData,
        tuesday: !isEmpty(nextProps.onboarding.tuesday)
          ? nextProps.onboarding.tuesday
          : dayData,
        wednesday: !isEmpty(nextProps.onboarding.wednesday)
          ? nextProps.onboarding.wednesday
          : dayData,
        thursday: !isEmpty(nextProps.onboarding.thursday)
          ? nextProps.onboarding.thursday
          : dayData,
        friday: !isEmpty(nextProps.onboarding.friday)
          ? nextProps.onboarding.friday
          : dayData,
        saturday: !isEmpty(nextProps.onboarding.saturday)
          ? nextProps.onboarding.saturday
          : dayData,
        sunday: !isEmpty(nextProps.onboarding.sunday)
          ? nextProps.onboarding.sunday
          : dayData,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    return null;
  }

  openModal = (e) => {
    e.preventDefault();
    this.setState({ open: true });
  };

  closedModal = (e) => {
    this.setState({ open: false });
  };

  handleChange = (time, day, label, inputType) => {
    if (label !== undefined && inputType === "opening") {
      let state = this.state;
      let dayData = state[day];
      let foodTimeData = dayData[label];
      foodTimeData.opening_time = new Date(time);
      this.setState({
        state: state,
        actionButton: true,
      });
    } else if (label !== undefined && inputType === "closing") {
      let state = this.state;
      let dayData = state[day];
      let foodTimeData = dayData[label];
      foodTimeData.closing_time = new Date(time);
      this.setState({
        state: state,
        actionButton: true,
      });
    }
  };

  handleChangeOpeningCloseing = (time, day, inputType, index) => {
    if (inputType === "opening_time") {
      let state = this.state;
      let dayData = state[day];
      let multipleOpening = dayData.multipleHours;
      multipleOpening[index].opening_time = new Date(time);
      this.setState({
        state: state,
        actionButton: true,
      });
    } else if (inputType === "closing_time") {
      let state = this.state;
      let dayData = state[day];
      let multipleClosing = dayData.multipleHours;
      multipleClosing[index].closing_time = new Date(time);
      this.setState({
        state: state,
        actionButton: true,
      });
    }
  };

  handleChangeMultipleHoursToggle = (day, hours, index) => (e) => {
    let state = this.state;
    let dayData = state[day];
    let multipleToggle = dayData.multipleHours;
    console.log(multipleToggle);
    multipleToggle[index].open = !multipleToggle[index].open;
    this.setState({
      state: state,
      actionButton: true,
    });
  };

  copyMultipleTimeFunction = (day) => (e) => {
    e.preventDefault();
    let state = this.state;
    let dayData = state[day];
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    let index = days.indexOf(day);
    days = days.slice(index + 1, days.length);
    let daysData = {};
    days.forEach((day) => {
      daysData[day] = JSON.parse(JSON.stringify(dayData));
    });
    console.log(daysData, days);
    this.setState({
      ...daysData,
    });
  };

  copyMultipleTimeFunctionError = (e) => {
    const { errors } = this.state;
    errors.description = "Description Is Required";
    this.setState({
      errors: errors,
    });
  };

  handleChangeInputTextArray = (day, index) => (e) => {
    let state = this.state;
    let dayData = state[day];
    let multipleText = dayData.multipleHours;
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    multipleText[index][e.target.name] = newData;

    this.setState({
      state: state,
      actionButton: true,
      checkPoint: false,
    });
  };

  /*****************************************
   * @DESC - Multiple Time Add Handlers
   ******************************************/
  onMultipleAddHandler = (day) => (e) => {
    e.preventDefault();
    let state = this.state;
    let dayData = state[day];
    let phone = dayData.multipleHours;
    let dayDataDesc = phone[phone.length - 1].description;
    if (dayDataDesc === "") {
      const { errors } = this.state;
      errors.description = "Description Is Required";
      this.setState({
        errors: errors,
      });
    } else {
      let newMultiple = {
        open: true,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 23),
        description: "",
      };
      phone.push(newMultiple);
      this.setState({
        state: state,
        checkPoint: true,
      });
    }
  };

  onMultileDeleteHandler = (day, index) => (e) => {
    e.preventDefault();
    let state = this.state;
    let dayData = state[day];
    let phone = dayData.multipleHours;
    if (phone.length === 1) {
      window.alert("Cannot Delete elements");
    } else {
      phone.splice(index, 1);
      this.setState({ state: state, errors: [] });
    }
    this.props.clear_all_errors();
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `Description Is Required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  /******************************************
   * @DESC Back Button Click Handler
   ****************************************/
  onClickHomeButtonHandlerOne = (e) => {
    this.setState({
      displayBusinessHours: !this.state.displayBusinessHours,
      // displayAreYouOpen: !this.state.displayAreYouOpen,
      // displayAreYouOpenInside: false,
      displayMultipleStandardHoursInside:
        !this.state.displayMultipleStandardHoursInside,
      areYouOpen: !isEmpty(this.props.onboarding.are_you_open_24_x_7)
        ? this.props.onboarding.are_you_open_24_x_7
        : false,
      multipleHoursOpening: !isEmpty(
        this.props.onboarding.multiple_opening_time
      )
        ? this.props.onboarding.multiple_opening_time
        : true,
    });
  };

  onClickHomeButtonHandler = (e) => {
    this.setState({
      displayBusinessHours: !this.state.displayBusinessHours,
      // displayAreYouOpen: !this.state.displayAreYouOpen,
      // displayAreYouOpenInside: false,
      displayMultipleStandardHoursInside:
        !this.state.displayMultipleStandardHoursInside,
      areYouOpen: !isEmpty(this.props.onboarding.are_you_open_24_x_7)
        ? this.props.onboarding.are_you_open_24_x_7
        : false,
      multipleHoursOpening: !isEmpty(
        this.props.onboarding.multiple_opening_time
      )
        ? this.props.onboarding.multiple_opening_time
        : true,
      monday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      tuesday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      wednesday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      thursday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      friday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      saturday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      sunday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
    });
  };

  /******************************************
   * @DESC Are You Open Button Click Handler
   ****************************************/
  areYouOpenBackButtonHandler = (e) => {
    this.setState({
      displayAreYouOpen: !this.state.displayAreYouOpen,
      displayStandardHours: false,
      displayMultipleStandardHours: false,
      displayBusinessHours: true,
    });
  };

  areYouOpenYesButtonClickHandler = (e) => {
    e.preventDefault();
    let mondayData = this.state.monday;
    let tuesdayData = this.state.tuesday;
    let wednesdayData = this.state.wednesday;
    let thursdayData = this.state.thursday;
    let fridayData = this.state.friday;
    let saturdayData = this.state.saturday;
    let sundayData = this.state.sunday;

    var newMondayData = mondayData.multipleHours;
    newMondayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    mondayData.multipleHours = newMondayData;

    var newTuesdayData = tuesdayData.multipleHours;
    newTuesdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    tuesdayData.multipleHours = newTuesdayData;

    var newWednesdayData = wednesdayData.multipleHours;
    newWednesdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    wednesdayData.multipleHours = newWednesdayData;

    var newThursdayData = thursdayData.multipleHours;
    newThursdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    thursdayData.multipleHours = newThursdayData;

    var newFridayData = fridayData.multipleHours;
    newFridayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    fridayData.multipleHours = newFridayData;

    var newSaturdayData = saturdayData.multipleHours;
    newSaturdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    saturdayData.multipleHours = newSaturdayData;

    var newSundayData = sundayData.multipleHours;
    newSundayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    sundayData.multipleHours = newSundayData;

    if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        display_business_hours: this.state.displayBusinessHours,
        display_are_you_open_inside: this.state.displayAreYouOpenInside,
        display_standard_hours_inside: this.state.displayStandardHoursInside,
        display_multiple_standard_hours_inside:
          this.state.displayMultipleStandardHoursInside,

        are_you_open_24_x_7: true,
        multiple_opening_time: this.state.multipleHoursOpening,
        monday: mondayData,
        tuesday: tuesdayData,
        wednesday: wednesdayData,
        thursday: thursdayData,
        friday: fridayData,
        saturday: saturdayData,
        sunday: sundayData,
        page_completed_till: 20,
      };
      // console.log(formData);
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/bankdetailshome");
    }
  };

  areYouOpenNoButtonClickHandler = (e) => {
    this.setState({
      displayAreYouOpen: false,
      displayMultipleStandardHours: true,
    });
  };

  /******************************************
   * @DESC Multiple Standard Hours Button Click Handler
   ****************************************/
  multipleStandardHoursNoButtonClicked = (e) => {
    this.setState({
      displayAreYouOpen: false,
      displayStandardHours: false,
      displayMultipleStandardHours: false,
    });
  };
  multipleStandardHoursYesButtonClicked = (e) => {
    this.setState({
      displayMultipleStandardHours: false,
      displayMultipleStandardHoursInside: true,
      // multipleHoursOpening: !this.state.multipleHoursOpening,
      areYouOpen: true,
      multipleHoursOpening: true,
      monday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      tuesday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      wednesday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      thursday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      friday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      saturday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
      sunday: {
        open: false,
        breakfast: {
          open: false,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
        },
        lunch: {
          open: false,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
        },
        dinner: {
          open: false,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
        },
        multipleHours: [
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
            description: "Breakfast",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
            description: "Lunch",
          },
          {
            open: true,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
            description: "Dinner",
          },
        ],
      },
    });
  };
  multipleStandardHoursBackButtonClicked = (e) => {
    this.setState({
      displayMultipleStandardHours: false,
      displayAreYouOpen: true,
    });
  };
  multipleHoursInsideBackButtonClicked = (e) => {
    this.setState({
      displayMultipleStandardHoursInside: false,
      displayAreYouOpen: false,
      multipleHoursOpening: false,
      areYouOpen: false,
      // displayMultipleStandardHours: true,
      displayBusinessHours: true,
    });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  handleChangeAreYouOpen = (e) => {
    this.setState({
      openAreYouOpenTogglePop: true,
      actionButton: true,
    });
  };

  closedAreYouOpenToggle = (e) => {
    this.setState({
      openAreYouOpenTogglePop: false,
    });
  };

  changedAreYouOpenToMultiple = (e) => {
    if (this.state.multipleHoursOpening === false) {
      this.setState({
        openAreYouOpenTogglePop: false,
        areYouOpen: !this.state.areYouOpen,
        multipleHoursOpening: !this.state.multipleHoursOpening,
        actionButton: true,
        monday: {
          open: false,
          breakfast: {
            open: false,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
          },
          lunch: {
            open: false,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
          },
          dinner: {
            open: false,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
          },
          multipleHours: [
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 8),
              closing_time: new Date(2020, 1, 1, 11),
              description: "Breakfast",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 13),
              closing_time: new Date(2020, 1, 1, 15),
              description: "Lunch",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 17),
              closing_time: new Date(2020, 1, 1, 23),
              description: "Dinner",
            },
          ],
        },
        tuesday: {
          open: false,
          breakfast: {
            open: false,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
          },
          lunch: {
            open: false,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
          },
          dinner: {
            open: false,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
          },
          multipleHours: [
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 8),
              closing_time: new Date(2020, 1, 1, 11),
              description: "Breakfast",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 13),
              closing_time: new Date(2020, 1, 1, 15),
              description: "Lunch",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 17),
              closing_time: new Date(2020, 1, 1, 23),
              description: "Dinner",
            },
          ],
        },
        wednesday: {
          open: false,
          breakfast: {
            open: false,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
          },
          lunch: {
            open: false,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
          },
          dinner: {
            open: false,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
          },
          multipleHours: [
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 8),
              closing_time: new Date(2020, 1, 1, 11),
              description: "Breakfast",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 13),
              closing_time: new Date(2020, 1, 1, 15),
              description: "Lunch",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 17),
              closing_time: new Date(2020, 1, 1, 23),
              description: "Dinner",
            },
          ],
        },
        thursday: {
          open: false,
          breakfast: {
            open: false,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
          },
          lunch: {
            open: false,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
          },
          dinner: {
            open: false,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
          },
          multipleHours: [
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 8),
              closing_time: new Date(2020, 1, 1, 11),
              description: "Breakfast",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 13),
              closing_time: new Date(2020, 1, 1, 15),
              description: "Lunch",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 17),
              closing_time: new Date(2020, 1, 1, 23),
              description: "Dinner",
            },
          ],
        },
        friday: {
          open: false,
          breakfast: {
            open: false,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
          },
          lunch: {
            open: false,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
          },
          dinner: {
            open: false,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
          },
          multipleHours: [
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 8),
              closing_time: new Date(2020, 1, 1, 11),
              description: "Breakfast",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 13),
              closing_time: new Date(2020, 1, 1, 15),
              description: "Lunch",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 17),
              closing_time: new Date(2020, 1, 1, 23),
              description: "Dinner",
            },
          ],
        },
        saturday: {
          open: false,
          breakfast: {
            open: false,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
          },
          lunch: {
            open: false,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
          },
          dinner: {
            open: false,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
          },
          multipleHours: [
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 8),
              closing_time: new Date(2020, 1, 1, 11),
              description: "Breakfast",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 13),
              closing_time: new Date(2020, 1, 1, 15),
              description: "Lunch",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 17),
              closing_time: new Date(2020, 1, 1, 23),
              description: "Dinner",
            },
          ],
        },
        sunday: {
          open: false,
          breakfast: {
            open: false,
            opening_time: new Date(2020, 1, 1, 8),
            closing_time: new Date(2020, 1, 1, 11),
          },
          lunch: {
            open: false,
            opening_time: new Date(2020, 1, 1, 13),
            closing_time: new Date(2020, 1, 1, 15),
          },
          dinner: {
            open: false,
            opening_time: new Date(2020, 1, 1, 17),
            closing_time: new Date(2020, 1, 1, 23),
          },
          multipleHours: [
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 8),
              closing_time: new Date(2020, 1, 1, 11),
              description: "Breakfast",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 13),
              closing_time: new Date(2020, 1, 1, 15),
              description: "Lunch",
            },
            {
              open: true,
              opening_time: new Date(2020, 1, 1, 17),
              closing_time: new Date(2020, 1, 1, 23),
              description: "Dinner",
            },
          ],
        },
      });
    } else {
      this.setState({
        openAreYouOpenTogglePop: false,
        areYouOpen: !this.state.areYouOpen,
        multipleHoursOpening: !this.state.multipleHoursOpening,
        actionButton: true,
      });
    }
  };

  handleChangeMultipleOpeningTimes = (e) => {
    this.setState({
      openAreYouOpenTogglePop: true,
      // multipleHoursOpening,
      // areYouOpen: !this.state.areYouOpen,
      actionButton: true,
    });
  };

  /****************************
   * @DESC - DAY TOGGLER -
   ***************************/
  onDayOpenCloseHanlder = (day, foodTime, multiple) => (e) => {
    let state = this.state;
    let dayData = state[day];
    dayData.open = !dayData.open;
    this.setState({
      state: state,
      checkPoint: false,
      actionButton: true,
    });
    if (dayData.open === false && multiple === "single") {
      dayData.breakfast.open = false;
      dayData.lunch.open = false;
      dayData.dinner.open = false;
    } else {
      this.setState({
        state: state,
        actionButton: true,
      });
    }
    if (
      state["monday"].open === false &&
      state["tuesday"].open === false &&
      state["wednesday"].open === false &&
      state["thursday"].open === false &&
      state["friday"].open === false &&
      state["saturday"].open === false &&
      state["sunday"].open === false &&
      multiple === "multiple"
    ) {
      this.setState({
        multipleHoursOpening: true,
        areYouOpen: false,
        // areYouOpen: true,
        actionButton: true,
      });
    } else {
      this.setState({
        multipleHoursOpening: true,
        areYouOpen: false,
        actionButton: true,
      });
    }
  };

  onTimeSelectHandlerSingle = (day) => (e) => {
    let state = this.state;
    let dayData = state[day];
    dayData[e.target.name] = e.target.value;
    this.setState({
      state: state,
    });
  };

  onFoodTypeOpenClose = (day, food) => (e) => {
    let state = this.state;
    let dayData = state[day];
    let foodTimeData = dayData[food];
    if (foodTimeData.open === false) {
      foodTimeData.open = !foodTimeData.open;
      state[day][food] = {
        open: foodTimeData.open,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      };
    } else {
      foodTimeData.open = !foodTimeData.open;
      state[day][food] = {
        open: foodTimeData.open,
        opening_time: "",
        closing_time: "",
      };
    }
    this.setState({
      state: state,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/bankdetailshome",
    });
  };

  onHandleSubmit = (e) => {
    let mondayData = this.state.monday;
    let tuesdayData = this.state.tuesday;
    let wednesdayData = this.state.wednesday;
    let thursdayData = this.state.thursday;
    let fridayData = this.state.friday;
    let saturdayData = this.state.saturday;
    let sundayData = this.state.sunday;

    var newMondayData = mondayData.multipleHours;
    newMondayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    mondayData.multipleHours = newMondayData;

    var newTuesdayData = tuesdayData.multipleHours;
    newTuesdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    tuesdayData.multipleHours = newTuesdayData;

    var newWednesdayData = wednesdayData.multipleHours;
    newWednesdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    wednesdayData.multipleHours = newWednesdayData;

    var newThursdayData = thursdayData.multipleHours;
    newThursdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    thursdayData.multipleHours = newThursdayData;

    var newFridayData = fridayData.multipleHours;
    newFridayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    fridayData.multipleHours = newFridayData;

    var newSaturdayData = saturdayData.multipleHours;
    newSaturdayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    saturdayData.multipleHours = newSaturdayData;

    var newSundayData = sundayData.multipleHours;
    newSundayData.forEach((elements) => {
      elements.opening_time = moment(elements.opening_time).valueOf();
      elements.closing_time = moment(elements.closing_time).valueOf();
    });
    sundayData.multipleHours = newSundayData;

    if (this.props.onboarding && this.props.onboarding.multiple_opening_time) {
      if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
        const formData = {
          vendor_id: this.props.onboarding.vendor_id,
          id: this.props.onboarding._id,
          display_business_hours: this.state.displayBusinessHours,
          display_are_you_open_inside: this.state.displayAreYouOpenInside,
          display_standard_hours_inside: this.state.displayStandardHoursInside,
          display_multiple_standard_hours_inside:
            this.state.displayMultipleStandardHoursInside,
          timeZoneOffset: this.state.timeZoneOffset,
          are_you_open_24_x_7: this.state.areYouOpen,
          multiple_opening_time: this.state.multipleHoursOpening,
          monday: mondayData,
          tuesday: tuesdayData,
          wednesday: wednesdayData,
          thursday: thursdayData,
          friday: fridayData,
          saturday: saturdayData,
          sunday: sundayData,
        };
        this.props.create_and_update_restaurant(formData);
        this.props.history.push("/bankdetailshome");
      }
    } else {
      if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
        const formData = {
          vendor_id: this.props.onboarding.vendor_id,
          id: this.props.onboarding._id,
          display_business_hours: this.state.displayBusinessHours,
          display_are_you_open_inside: this.state.displayAreYouOpenInside,
          display_standard_hours_inside: this.state.displayStandardHoursInside,
          display_multiple_standard_hours_inside:
            this.state.displayMultipleStandardHoursInside,
          timeZoneOffset: this.state.timeZoneOffset,
          are_you_open_24_x_7: this.state.areYouOpen,
          multiple_opening_time: this.state.multipleHoursOpening,
          monday: mondayData,
          tuesday: tuesdayData,
          wednesday: wednesdayData,
          thursday: thursdayData,
          friday: fridayData,
          saturday: saturdayData,
          sunday: sundayData,
          page_completed_till: 20,
        };
        // console.log(formData);
        this.props.create_and_update_restaurant(formData);
        this.props.history.push("/bankdetailshome");
      }
    }
  };

  renderAllBusinessHoursPages = () => {
    const {
      displayAreYouOpen,
      displayStandardHours,
      // displayStandardHoursInside,
      displayMultipleStandardHours,
      displayMultipleStandardHoursInside,
      actionButton,
    } = this.state;
    if (displayAreYouOpen === true) {
      return this.renderAreYOuOpenHoursScreen();
    } else if (displayStandardHours === true) {
      return this.renderStandardHoursFields();
    } else if (displayMultipleStandardHours === true) {
      return this.renderMultipleStandardHoursFields();
    } else if (displayMultipleStandardHoursInside === true) {
      return (
        <React.Fragment>
          <div>
            <RenderMultipleHoursInsideFields
              state={this.state}
              errors={this.state.errors}
              onDayOpenCloseHanlder={this.onDayOpenCloseHanlder}
              onFoodTypeOpenClose={this.onFoodTypeOpenClose}
              multipleHoursInsideBackButtonClicked={
                this.multipleHoursInsideBackButtonClicked
              }
              multipleHoursNextButtonClicked={
                actionButton === false
                  ? this.onWithOutApiCall
                  : this.onHandleSubmit
              }
              handleChange={this.handleChange}
              multipleOpeningTimes={this.state.multipleHoursOpening}
              handleChangeMultiple={this.handleChangeMultipleOpeningTimes}
              addOnClick={this.onMultipleAddHandler}
              deleteOnClick={this.onMultileDeleteHandler}
              handleChangeOpeningCloseing={this.handleChangeOpeningCloseing}
              handleChangeInputTextArray={this.handleChangeInputTextArray}
              handleChangeMultipleHoursToggle={
                this.handleChangeMultipleHoursToggle
              }
              onFocusOut={this.onFocusOut}
              copyMultipleTimeFunctionError={this.copyMultipleTimeFunctionError}
              copyMultipleTimeFunction={this.copyMultipleTimeFunction}
              areYouOpen={this.state.areYouOpen}
              handleChangeseating={this.handleChangeAreYouOpen}
              /*** Toggle Popup Fun ***/
              // onOpenTogglePopup={this.openAreYouOpenTogglePopupFun}
              togglePopupState={this.state.openAreYouOpenTogglePop}
              onClosedTogglePopup={this.closedAreYouOpenToggle}
              onClickYesTogglePopup={this.changedAreYouOpenToMultiple}
            />
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div>
            <MainBusinessHoursHome
              onClickHome={
                this.state.multipleHoursOpening
                  ? this.onClickHomeButtonHandlerOne
                  : this.onClickHomeButtonHandler
              }
              handleFormHide={this.handleFormHide}
            />
          </div>
        </React.Fragment>
      );
    }
  };

  renderAreYOuOpenHoursScreen = () => {
    const { displayAreYouOpenInside, actionButton } = this.state;
    return (
      <React.Fragment>
        <AreYouOpen
          displayYesScreen={displayAreYouOpenInside}
          backButtonClicked={this.areYouOpenBackButtonHandler}
          backButtonClickedTwo={this.areYouOpenYesButtonClickHandler}
          onClickYes={this.areYouOpenYesButtonClickHandler}
          onClickNo={this.areYouOpenNoButtonClickHandler}
          areYouOpen={this.state.areYouOpen}
          handleChangeseating={this.handleChangeAreYouOpen}
          onClickHome={
            actionButton === false ? this.onWithOutApiCall : this.onHandleSubmit
          }
        />
      </React.Fragment>
    );
  };

  renderStandardHoursFields = () => {
    return (
      <React.Fragment>
        <StandardHours
          standardHoursYesButtonClicked={this.standardHoursYesButtonClicked}
          standardHoursNoButtonClicked={this.standardHoursNoButtonClicked}
          standardHoursBackButtonClicked={this.standardHoursBackButtonClicked}
        />
      </React.Fragment>
    );
  };

  renderMultipleStandardHoursFields = () => {
    return (
      <React.Fragment>
        <MultipleStandardHours
          multipleStandardHoursNoButtonClicked={
            this.multipleStandardHoursNoButtonClicked
          }
          mutipleStandardHoursYesButtonClicked={
            this.multipleStandardHoursYesButtonClicked
          }
          multipleStandardHoursBackButtonClicked={
            this.multipleStandardHoursBackButtonClicked
          }
        />
      </React.Fragment>
    );
  };

  onPageBackButtonHandle = (value) => (e) => {
    if (value === "businessHours") {
      this.props.history.push("/multicuisine");
    } else if (value === "areYouOpen") {
      this.setState({
        displayAreYouOpen: false,
        displayBusinessHours: false,
      });
    } else if (value === "standardHours") {
      this.setState({
        displayStandardHours: false,
        displayAreYouOpen: true,
      });
    } else if (value === "multipleStandardHours") {
      this.setState({
        displayMultipleStandardHours: false,
        // displayStandardHours: true,
        displayAreYouOpen: true,
      });
    } else if (value === "areYouOpenInside") {
      this.setState({
        displayAreYouOpenInside: false,
        displayAreYouOpen: true,
      });
    } else if (value === "standardHoursInside") {
      this.setState({
        displayStandardHoursInside: false,
        displayStandardHours: true,
      });
    } else if (value === "multipleStandardHoursInside") {
      this.props.history.push("/multicuisine");
    }
  };
  handleFormShow = () => {
    this.setState({ formShow: true });
  };
  handleFormHide = () => {
    this.setState({ formShow: false });
  };
  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    const {
      displayBusinessHours,
      displayAreYouOpen,
      displayStandardHours,
      displayMultipleStandardHours,
      displayAreYouOpenInside,
      displayStandardHoursInside,
      displayMultipleStandardHoursInside,
      formShow,
    } = this.state;
    return (
      <React.Fragment>
        <Media query="(max-width: 991px)">
          <>
            {!formShow && (
              <div className="bg-white min-height-100vh position-relative">
                <div className="mobileFirstScreen col-12">
                  <SliderMobileReusableComponent
                    displayShow={true}
                    selectedProgressBarOne="active"
                    selectedProgressBarTwo="active"
                    selectedProgressBarThree="active"
                    selectedProgressBarFour="active"
                    backLink={true}
                    onLink={"/multicuisine"}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-03.svg")}
                  />
                </div>
                <div className="col-12 py-4">
                  <div className="f20_700_HelveticaNeue">
                    Business Hours of Operations
                  </div>
                  {/* <div className="f16-400 opacity5">
                    Enter the details about your Business location
                  </div> */}
                </div>
                <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link={"/multicuisine"}
                  />
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="Next"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Next"
                    onClick={this.handleFormShow}
                  />
                </div>
              </div>
            )}
          </>
        </Media>
        <div className={`container-fluid formShow ${formShow ? "active" : ""}`}>
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              <div className="col-12 onboarding_process_screen_left-backbutton">
                {/* <span
                  className="back_button-link"
                  onClick={
                    displayBusinessHours === false
                      ? this.onPageBackButtonHandle("businessHours")
                      : displayStandardHours === true
                      ? this.onPageBackButtonHandle("standardHours")
                      : displayMultipleStandardHours === true
                      ? this.onPageBackButtonHandle("multipleStandardHours")
                      : displayAreYouOpenInside === true
                      ? this.onPageBackButtonHandle("areYouOpenInside")
                      : displayStandardHoursInside === true
                      ? this.onPageBackButtonHandle("standardHoursInside")
                      : displayMultipleStandardHoursInside === true
                      ? this.onPageBackButtonHandle(
                          "multipleStandardHoursInside"
                        )
                      : displayAreYouOpen === true
                      ? this.onPageBackButtonHandle("areYouOpen")
                      : null
                  }
                >
                  <Image
                    src={require("../../../../assets/images/Icon/onBoardBack.png")}
                    alt="Back Button"
                    title="Back Button"
                  />
                </span> */}
                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      displayArrow={true}
                      workWithLinkORClick={true}
                      backButtonClicked={
                        this.state.displayMultipleStandardHoursInside === true
                          ? this.multipleHoursInsideBackButtonClicked
                          : this.onPageBackButtonHandle(
                              "multipleStandardHoursInside"
                            )
                        // displayBusinessHours === false
                        //   ? this.onPageBackButtonHandle("businessHours")
                        //   : displayStandardHours === true
                        //   ? this.onPageBackButtonHandle("standardHours")
                        //   : displayMultipleStandardHours === true
                        //   ? this.onPageBackButtonHandle("multipleStandardHours")
                        //   : displayAreYouOpenInside === true
                        //   ? this.onPageBackButtonHandle("areYouOpenInside")
                        //   : displayStandardHoursInside === true
                        //   ? this.onPageBackButtonHandle("standardHoursInside")
                        //   : displayMultipleStandardHoursInside === true
                        //   ? this.onPageBackButtonHandle(
                        //       "multipleStandardHoursInside"
                        //     )
                        //   : displayAreYouOpen === true
                        //   ? this.onPageBackButtonHandle("areYouOpen")
                        //   : null
                      }
                    />
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    onClick={
                      this.state.displayMultipleStandardHoursInside === true
                        ? this.multipleHoursInsideBackButtonClicked
                        : this.handleFormHide
                    }
                  />
                </Media>
              </div>
              {/* <div className="display-toggle-stepup-button">
                <RightSidePannel selectedTab={this.state.selectedTab} />
              </div> */}
              <div className="onboarding_process_screen-left-mapinside">
                <div className="business_and_hours_onboarding_main">
                  <Form noValidate>{this.renderAllBusinessHoursPages()}</Form>
                </div>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                selectedProgressBarTwo="active"
                selectedProgressBarThree="active"
                selectedProgressBarFour="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-03.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MainBusinessHours.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  category: state.category,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(MainBusinessHours));

const RenderMultipleHoursInsideFields = ({
  state,
  errors,
  areYouOpen,
  handleChangeseating,

  onOpenTogglePopup,
  togglePopupState,
  onClosedTogglePopup,
  onClickYesTogglePopup,

  onDayOpenCloseHanlder,
  multipleHoursInsideBackButtonClicked,
  multipleHoursNextButtonClicked,
  multipleOpeningTimes,
  handleChangeMultiple,
  handleChangeOpeningCloseing,
  handleChangeInputTextArray,
  handleChangeMultipleHoursToggle,
  onFocusOut,
  deleteOnClick,
  addOnClick,
  copyMultipleTimeFunction,
  copyMultipleTimeFunctionError,
}) => {
  const dayDataMonData = state["monday"].multipleHours;
  let dayDataMonDataDesc =
    dayDataMonData[dayDataMonData.length - 1].description;
  const dayDataTueData = state["tuesday"].multipleHours;
  let dayDataTueDataDesc =
    dayDataTueData[dayDataTueData.length - 1].description;
  const dayDataWedData = state["wednesday"].multipleHours;
  let dayDataWedDataDesc =
    dayDataWedData[dayDataWedData.length - 1].description;
  const dayDataThrData = state["thursday"].multipleHours;
  let dayDataThrDataDesc =
    dayDataThrData[dayDataThrData.length - 1].description;
  const dayDataFriData = state["friday"].multipleHours;
  let dayDataFriDataDesc =
    dayDataFriData[dayDataFriData.length - 1].description;
  const dayDataSatData = state["saturday"].multipleHours;
  let dayDataSatDataDesc =
    dayDataSatData[dayDataSatData.length - 1].description;
  const dayDataSunData = state["sunday"].multipleHours;
  let dayDataSunDataDesc =
    dayDataSunData[dayDataSunData.length - 1].description;

  console.log(state, "***************");

  return (
    <React.Fragment>
      <div>
        <TopTextReusableComponent
          headingText="Business Timings"
          headingParagraph="Enter the details about the timing of your Business"
        />
      </div>
      <div className="multiple-opening-time-section">
        <div className="row multiple-opening-time-sectionone-toggle mt-4">
          <div className="col-10">
            <div className="f16-700">Are you open 24x7</div>
            <div className="f11-400 opacity5">
              If your Business is open for 24 hours then select the option
            </div>
          </div>
          <div className="col-2">
            <Switch
              checked={areYouOpen}
              onChange={handleChangeseating}
              offColor="#EEEEEE"
              onColor="#EEEEEE"
              offHandleColor="#212121"
              onHandleColor="#59F832"
              handleDiameter={20}
              uncheckedIcon={false}
              checkedIcon={false}
              height={14}
              width={34}
              boxShadow="-2px 0px 5px #0000003B"
              activeBoxShadow="-2px 0px 5px #0000003B"
              id="material-switch"
            />
          </div>

          <TogglePopup
            // onOpenTogglePopup={onOpenTogglePopup}
            togglePopupState={togglePopupState}
            onClosedTogglePopup={onClosedTogglePopup}
            onClickYesTogglePopup={onClickYesTogglePopup}
            displayAreyouOpen={state.areYouOpen}
            displayMultipleOpen={state.multipleHoursOpening}
          />
        </div>
      </div>
      <hr />
      <div className="multiple-opening-time-section ">
        <div className="row multiple-opening-time-sectionone-toggle ">
          <div className="col-10">
            <div className="f16-700">Do you have multiple opening times?</div>
            <div className="f11-400 opacity5">
              If you have multiple opening hours then adjust your time below
            </div>
          </div>
          <div className="col-2">
            <Switch
              checked={multipleOpeningTimes}
              onChange={handleChangeMultiple}
              offColor="#EEEEEE"
              onColor="#EEEEEE"
              offHandleColor="#212121"
              onHandleColor="#59F832"
              handleDiameter={20}
              uncheckedIcon={false}
              checkedIcon={false}
              height={14}
              width={34}
              boxShadow="-2px 0px 5px #0000003B"
              activeBoxShadow="-2px 0px 5px #0000003B"
              id="material-switch"
            />
          </div>
        </div>
      </div>
      {multipleOpeningTimes && (
        <div className="f15-700 mt-4">Day of the week you operate?</div>
      )}
      {multipleOpeningTimes === true ? (
        <div className="margin-new-multiple-hours mb-5">
          {dayArray.map((day, index) => (
            <React.Fragment key={index}>
              <div className="standard-hours-main">
                <div className="standard-hours-main-sectionone">
                  <Switch
                    checked={state[day].open}
                    onChange={onDayOpenCloseHanlder(day, foodTime, "multiple")}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={15}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={10}
                    width={28}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                  <div className="f12-500 text-uppercase pl-2">{day}</div>
                </div>
                {state[day].open === true ? (
                  <div className="">
                    {state[day].multipleHours.map((hours, index) => (
                      <div
                        className="row mb-4 mt-3 pl-4 standard-hours-main-sectiontwo"
                        key={index}
                      >
                        <div className="col-9 col-md-5 col-lg-5 col-xl-5 pr-lg-0">
                          <div className="d-flex align-items-center justify-content-md-between">
                            <Switch
                              checked={hours.open}
                              onChange={handleChangeMultipleHoursToggle(
                                day,
                                hours,
                                index
                              )}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={15}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={10}
                              width={28}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                            <NewInputText
                              extraClass="mb-0 ml-3"
                              inputType="text"
                              onChange={handleChangeInputTextArray(day, index)}
                              onFocusOut={onFocusOut}
                              onKeyDown={InputCharacterCheck}
                              value={hours.description}
                              name="description"
                              errorText={
                                hours.description === ""
                                  ? errors.description
                                  : ""
                              }
                              errorTrue={
                                hours.description === "" &&
                                errors.description === "Description Is Required"
                                  ? true
                                  : false
                              }
                              disabled={hours.open === true ? false : true}
                              labelText="Description"
                              controlClass={
                                hours.description === "" &&
                                errors.description === "Description Is Required"
                                  ? "outlined-error-helper-text"
                                  : "outlined-helperText"
                              }
                            />
                          </div>
                        </div>
                        <div className="pt-m-10 pl-64 mobile-order-3 col-6 col-md-2 col-lg-3 col-xl-3 standard-hours-main-sectiontwo-insidetoggle ">
                          {/* mobile-standard-hours-mainpending */}
                          <TimeInput
                            mode="12h"
                            // placeholder="Select Time"
                            value={new Date(hours.opening_time)}
                            disabled={hours.open === true ? false : true}
                            onChange={(time) =>
                              handleChangeOpeningCloseing(
                                time,
                                day,
                                "opening_time",
                                index
                              )
                            }
                          />
                        </div>
                        <div className="pt-m-10 mobile-order-4 col-3 col-md-2 col-lg-3 col-xl-3 standard-hours-main-sectiontwo-insidetoggle mobile-standard-hours-mainpending">
                          {/* standard-hours-main-sectionthree-multi */}
                          <TimeInput
                            mode="12h"
                            // placeholder="Select Time"
                            value={new Date(hours.closing_time)}
                            disabled={hours.open === true ? false : true}
                            onChange={(time) =>
                              handleChangeOpeningCloseing(
                                time,
                                day,
                                "closing_time",
                                index
                              )
                            }
                          />
                        </div>
                        <div className="col-3 col-md-3 col-lg-1 col-xl-1 p-0 d-flex align-items-center justify-content-between">
                          {state[day].multipleHours.length > 1 ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Delete"
                                onClick={deleteOnClick(day, index)}
                                fontIcon="fa fa-trash-o"
                                colorCss="delete"
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ))}
                    <div className="col-12 d-flex p-0 restaurant_details_onboarding_minus_button">
                      <div className="col-6">
                        <AddButtonIconComponent
                          buttonText="Add Another Slot"
                          onClick={addOnClick(day)}
                          fontIcon="fa fa-plus"
                          colorCss="blue"
                        />
                      </div>
                      <div className="col-6 d-flex justify-content-end">
                        <AddButtonIconComponent
                          buttonText="Copy Timing to Rest of the Days"
                          onClick={
                            (dayDataMonDataDesc === "" &&
                              dayDataTueDataDesc === "" &&
                              dayDataWedDataDesc === "" &&
                              dayDataThrDataDesc === "" &&
                              dayDataFriDataDesc === "" &&
                              dayDataSatDataDesc === "" &&
                              dayDataSunDataDesc === "") ||
                            state.checkPoint === true
                              ? copyMultipleTimeFunctionError
                              : copyMultipleTimeFunction(day)
                          }
                          fontIcon="fa fa-clone"
                          colorCss="red"
                          //
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
      ) : null}
      <div className="col-12 map-button-box-main">
        {multipleOpeningTimes && (
          <BusinessHoursMultiplePopup
            monday={state.monday}
            tuesday={state.tuesday}
            wednesday={state.wednesday}
            thursday={state.thursday}
            friday={state.friday}
            saturday={state.saturday}
            sunday={state.sunday}
          />
        )}
      </div>
      <div className="onboarding-map-setup-screen-autodetect-button">
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          buttonType="button"
          onClick={multipleHoursInsideBackButtonClicked}
        />
        {state.areYouOpen === true ? (
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={multipleHoursNextButtonClicked}
          />
        ) : (
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass={
              (state["monday"].open === false &&
                state["tuesday"].open === false &&
                state["wednesday"].open === false &&
                state["thursday"].open === false &&
                state["friday"].open === false &&
                state["saturday"].open === false &&
                state["sunday"].open === false) ||
              (dayDataMonDataDesc === "" &&
                dayDataTueDataDesc === "" &&
                dayDataWedDataDesc === "" &&
                dayDataThrDataDesc === "" &&
                dayDataFriDataDesc === "" &&
                dayDataSatDataDesc === "" &&
                dayDataSunDataDesc === "") ||
              state.errors.description === "Description Is Required" ||
              state.checkPoint === true
                ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            }
            disabled={
              (state["monday"].open === false &&
                state["tuesday"].open === false &&
                state["wednesday"].open === false &&
                state["thursday"].open === false &&
                state["friday"].open === false &&
                state["saturday"].open === false &&
                state["sunday"].open === false) ||
              (dayDataMonDataDesc === "" &&
                dayDataTueDataDesc === "" &&
                dayDataWedDataDesc === "" &&
                dayDataThrDataDesc === "" &&
                dayDataFriDataDesc === "" &&
                dayDataSatDataDesc === "" &&
                dayDataSunDataDesc === "") ||
              state.errors.description === "Description Is Required" ||
              state.checkPoint === true
                ? true
                : false
            }
            buttonText="Next"
            buttonType="button"
            onClick={multipleHoursNextButtonClicked}
          />
        )}
      </div>
    </React.Fragment>
  );
};

//16-09-2020
